import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import { getMetadataItems } from "../../Utils/Entry";

const useStyles = makeStyles((theme) => ({
    metadata: {
        display:"flex", 
        flexWrap: "wrap",
    },
    metadataItem: {
        lineHeight: "1",
        paddingTop: ".2em",
        borderLeft: "2px solid",
        paddingLeft: ".5rem",
        paddingRight: ".5rem",
        "&:first-child": {
            paddingLeft: 0,
            borderLeft: "none",
        }
    },
}));

export default function Metadata({ entry, ...props }) {
    const classes = useStyles();
    const metadataItems = React.useMemo(
        () => getMetadataItems(entry.data, entry.judgingMediaType === 'video', entry.hasRuntime),
        [entry],
    );
        
    return (
        <Typography 
            className={classes.metadata} 
            variant="body2" 
            color="textSecondary" 
            component="div" 
            {...props}
        >
            {metadataItems.map((metaItem, i) => (
                <span key={i} className={classes.metadataItem}>
                    { metaItem.answer }
                </span>
            ))}
        </Typography>
    );
}